module.exports = __webpack_public_path__ + "img/bottom_icon7.1b419a38_1b419a3842a7fca6e2ebb68ac697dd25.1b419a38.png";